
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/free-conversation",
      function () {
        return require("private-next-pages/courses/free-conversation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/free-conversation"])
      });
    }
  